import { ADD_LEADERBOARD } from "../constants/leaderboardConstants";

const leaderboardReducer = (state = [], action) => {
  switch (action.type) {
    case ADD_LEADERBOARD:
      if (Array.isArray(action.payload)) {
        return [...state, ...action.payload];
      } else {
        return [...state, action.payload];
      }
    default:
      return state;
  }
};

export default leaderboardReducer;
